import React from 'react';

import Tabs from '../generic/Tabs';
import Titled from '../layout/Titled';
import ListContactLists from './contact-lists/ListContactLists/ListContactLists';
import ListContactsWithFilters from './ListContacts/ListContactsWithFilters';

export default function ContactsHome() {
  return (
    <Titled title="Contacts">
      <Tabs
        id="contactsHome"
        tabs={[
          {
            label: 'All',
            value: 'allContacts',
            content: (
              <div className="pt-3">
                <ListContactsWithFilters />
              </div>
            ),
          },
          {
            label: 'Contact lists',
            value: 'contactLists',
            content: (
              <div className="pt-3">
                <ListContactLists title="" />
              </div>
            ),
          },
        ]}
      />
    </Titled>
  );
}
